import React from 'react';
import CarrotCharacter from './CarrotCharacter';
import PotatoCharacter from './PotatoCharacter';
import BroccoliCharacter from './BroccoliCharacter';
import CucumberCharacter from "./CucumberCharacter.jsx";
import TomatoCharacter from "./TomatoCharacter.jsx";
import OnionCharacter from "./OnionCharacter.jsx";
import GarlicCharacter from "./GarlicCharacter.jsx";
import TurnipCharacter from "./TurnipCharacter.jsx";
import AubergineCharacter from "./AubergineCharacter.jsx";
// Import other vegetable characters as you create them

const VegetableCharacterFactory = ({ vegetableType, ...props }) => {
    // Map vegetable names to their component implementations
    const characterComponents = {
        'Carrot': CarrotCharacter,
        'Potato': PotatoCharacter,
        'Broccoli': BroccoliCharacter,
        'Cucumber': CucumberCharacter,
        'Tomato': TomatoCharacter,
        'Onion': OnionCharacter,
        'Garlic': GarlicCharacter,
        'Turnip': TurnipCharacter,
        'Aubergine': AubergineCharacter,
        'default': CarrotCharacter, // Default to Carrot if no specific character is found
    };

    // Get the appropriate character component
    const CharacterComponent = characterComponents[vegetableType];

    // If we have a component for this vegetable type, render it
    if (CharacterComponent) {
        return <CharacterComponent {...props} />;
    }

    // Fallback for vegetables without a specific character implementation
    // Use a default character with appropriate coloring based on the vegetable type
    return (
        <CarrotCharacter
            {...props}
            primaryColor={getVegetableColor(vegetableType)}
            secondaryColor={getDarkerShade(getVegetableColor(vegetableType))}
        />
    );
};

// Helper function to get a color for vegetables without custom characters
const getVegetableColor = (vegetableType) => {
    const colorMap = {
        'Cucumber': '#2e7d32',
        'Tomato': '#d32f2f',
        'Onion': '#e0e0e0',
        'Garlic': '#f5f5f5',
        'Turnip': '#f48fb1',
        'Aubergine': '#7b1fa2',
        'Corn': '#fdd835',
        // Default color for unknown vegetables
        'default': '#a5d6a7'
    };

    return colorMap[vegetableType] || colorMap.default;
};

// Helper function to get a darker shade of a color for secondary elements
const getDarkerShade = (hexColor) => {
    // Convert hex to RGB
    let r = parseInt(hexColor.slice(1, 3), 16);
    let g = parseInt(hexColor.slice(3, 5), 16);
    let b = parseInt(hexColor.slice(5, 7), 16);

    // Darken by reducing each component by 20%
    r = Math.max(0, Math.floor(r * 0.8));
    g = Math.max(0, Math.floor(g * 0.8));
    b = Math.max(0, Math.floor(b * 0.8));

    // Convert back to hex
    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
};

export default VegetableCharacterFactory;
